export default {
  common: {
    save: "ಉಳಿಸಿ",
    cancel: "ರದ್ದುಮಾಡಿ",
    back: "ಹಿಂದೆ",
    submit: "ಸಲ್ಲಿಸಿ",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
    yes: "ಹೌದು",
    no: "ಇಲ್ಲ",
    confirm: "ದೃಢೀಕರಿಸಿ",
    close: "ಮುಚ್ಚಿ",
    search: "ಹುಡುಕಿ",
    all: "ಎಲ್ಲಾ",
    done: "ಮುಗಿದಿದೆ",
    logout: "ಲಾಗ್ ಔಟ್",
    language: "ಭಾಷೆ",
    selectLanguage: "ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    saving: "ಉಳಿಸಲಾಗುತ್ತಿದೆ…",
    saved: "ಉಳಿಸಲಾಗಿದೆ",
    viewAll: "ಎಲ್ಲವನ್ನೂ ನೋಡಿ",
    filters: "ಫಿಲ್ಟರ್‌ಗಳು",
  },
  nav: {
    home: "ಮುಖಪುಟ",
    installs: "ಅಳವಡಿಕೆಗಳು",
    requests: "ವಿನಂತಿಗಳು",
    orders: "ಆರ್ಡರ್‌ಗಳು",
    profile: "ಪ್ರೊಫೈಲ್",
    leads: "ಲೀಡ್ಸ್",
    service: "ಸೇವೆ",
    payouts: "ಪಾವತಿಗಳು",
    toolkit: "ಟೂಲ್‌ಕಿಟ್",
  },
  profile: {
    yourAccount: "ನಿಮ್ಮ ಖಾತೆ",
    title: "ಪ್ರೊಫೈಲ್.",
    city: "ನಗರ",
    state: "ರಾಜ್ಯ",
    pinCode: "ಪಿನ್ ಕೋಡ್",
    pinCodeHelp: "ಈ ಪಿನ್ ಕೋಡ್ ಸೇರಿರುವ ಅನುಮತಿಸಲಾದ ಪ್ರದೇಶವೇ ನಿಮ್ಮ ಪ್ರಾಂತ್ಯ.",
    upiId: "UPI ಐಡಿ (ಪಾವತಿಗಳಿಗಾಗಿ)",
    saveProfile: "ಪ್ರೊಫೈಲ್ ಉಳಿಸಿ",
    preferredLanguage: "ಆದ್ಯತೆಯ ಭಾಷೆ",
    logoutConfirm: "ನೀವು ಖಚಿತವಾಗಿ ಲಾಗ್ ಔಟ್ ಮಾಡಲು ಬಯಸುವಿರಾ?",
    linkedAddresses: "ಲಿಂಕ್ ಮಾಡಲಾದ ವಿಳಾಸಗಳು",
    noAddresses: "ಇನ್ನೂ ಯಾವುದೇ ವಿಳಾಸ ಉಳಿಸಿಲ್ಲ.",
    referFriend: "ಸ್ನೇಹಿತರನ್ನು ರೆಫರ್ ಮಾಡಿ",
    referFriendSub: "ನಿಮ್ಮ ಕೋಡ್ ಹಂಚಿಕೊಳ್ಳಿ — ಅವರು ಸೋಲಾರ್ ಅಳವಡಿಸಿದಾಗ ನಿಮಗೆ ಬಹುಮಾನ ಸಿಗುತ್ತದೆ.",
    myReferrals: "ನನ್ನ ರೆಫರಲ್‌ಗಳು",
    shareFriend: "ಸ್ನೇಹಿತರೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಿ",
    secureNote: "ನಿಮ್ಮ ಡೇಟಾ ಸುರಕ್ಷಿತ ಫೋನ್ OTP ಮೂಲಕ ಪರಿಶೀಲಿಸಲ್ಪಟ್ಟಿದೆ — ಪಾಸ್‌ವರ್ಡ್ ನೆನಪಿಡುವ ಅಥವಾ ಕಳೆದುಕೊಳ್ಳುವ ಅಗತ್ಯವಿಲ್ಲ.",
    toolkit: "ಟೂಲ್‌ಕಿಟ್",
    incentiveSchemes: "ಪ್ರೋತ್ಸಾಹಕ ಯೋಜನೆಗಳು",
  },
  tickets: {
    myRequests: "ನನ್ನ ವಿನಂತಿಗಳು",
    raiseComplaint: "ದೂರು ದಾಖಲಿಸಿ",
    cancelRequest: "ವಿನಂತಿ ರದ್ದುಮಾಡಿ",
    cancelConfirmTitle: "ಈ ವಿನಂತಿಯನ್ನು ರದ್ದುಮಾಡುವುದೇ?",
    cancelConfirmBody: "ಈ ಸೇವಾ ವಿನಂತಿಯ ಕೆಲಸವನ್ನು ನಾವು ನಿಲ್ಲಿಸುತ್ತೇವೆ. ನೀವು ನಂತರ ಮತ್ತೆ ಹೊಸ ವಿನಂತಿ ಮಾಡಬಹುದು.",
    cancelledToast: "ವಿನಂತಿ ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ",
    keepRequest: "ಬೇಡ, ಇರಲಿ",
    noRequests: "ಇನ್ನೂ ಯಾವುದೇ ಸೇವಾ ವಿನಂತಿಗಳಿಲ್ಲ.",
    statusOpen: "ತೆರೆದಿದೆ",
    statusInProgress: "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    statusOnHold: "ಹಿಡಿದಿಟ್ಟಿದೆ",
    statusActionNeeded: "ಕ್ರಮ ಅಗತ್ಯ",
    statusCompleted: "ಪೂರ್ಣಗೊಂಡಿದೆ",
    statusClosed: "ಮುಚ್ಚಲಾಗಿದೆ",
    statusCancelled: "ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ",
    statusDropped: "ಕೈಬಿಡಲಾಗಿದೆ",
    filterAll: "ಎಲ್ಲಾ",
    filterActive: "ಸಕ್ರಿಯ",
    filterResolved: "ಪರಿಹರಿಸಲಾಗಿದೆ",
    nonServiceable: "ಸೇವೆ ಲಭ್ಯವಿಲ್ಲದ ಪ್ರದೇಶ",
    raisedOn: "ದಾಖಲಿಸಿದ ದಿನಾಂಕ",
    ticketNumber: "ಟಿಕೆಟ್",
    wipInstall: "ಅಳವಡಿಕೆ ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    raisedByYou: "ನೀವು ದಾಖಲಿಸಿದ್ದೀರಿ",
    raisedByTeam: "ನಮ್ಮ ತಂಡ ದಾಖಲಿಸಿದೆ",
    timeline: "ಟೈಮ್‌ಲೈನ್",
    pending: "ಬಾಕಿ ಇದೆ",
    resolutionSummary: "ಪರಿಹಾರ ಸಾರಾಂಶ",
    youRatedPrefix: "ನೀವು ಇದನ್ನು ರೇಟ್ ಮಾಡಿದ್ದೀರಿ",
    howWasResolution: "ಪರಿಹಾರ ಹೇಗಿತ್ತು?",
    submitFeedback: "ಫೀಡ್‌ಬ್ಯಾಕ್ ಸಲ್ಲಿಸಿ",
  },
  home: {
    greeting: "ನಮಸ್ಕಾರ",
    newInstallation: "ಹೊಸ ಅಳವಡಿಕೆ",
    raiseComplaint: "ದೂರು ದಾಖಲಿಸಿ",
    welcomeBack: "ಮತ್ತೆ ಸ್ವಾಗತ",
    customerSubtitle: "ಪೂರ್ವೋದಯದೊಂದಿಗೆ ನಿಮ್ಮ ಸೋಲಾರ್ ಪಯಣ, ಎಲ್ಲವೂ ಒಂದೇ ಕಡೆ.",
  },
  sc: {
    requestsTitle: "ಸೇವಾ ವಿನಂತಿಗಳು",
    requestsForCustomers: "ನಿಮ್ಮ ಗ್ರಾಹಕರಿಗಾಗಿ",
    kpiOpen: "ತೆರೆದಿದೆ",
    kpiResolved: "ಪರಿಹರಿಸಲಾಗಿದೆ",
    kpiInProblem: "ಸಮಸ್ಯೆಯಲ್ಲಿ",
    raiseRequest: "ಸೇವಾ ವಿನಂತಿ ದಾಖಲಿಸಿ",
    slaBreached: "SLA ಉಲ್ಲಂಘನೆ",
    viewPhotos: "ಫೋಟೋಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
    hidePhotos: "ಫೋಟೋಗಳನ್ನು ಮರೆಮಾಡಿ",
    noRequestsWindow: "ಈ ಅವಧಿಯಲ್ಲಿ ಯಾವುದೇ ಸೇವಾ ವಿನಂತಿಗಳಿಲ್ಲ.",
  },
};
